import { CorporationDto } from '../corporation/corporation.dto';

export interface CorporateLocationDto {
  id: string; // Guid
  corporationId: string; // Guid
  name: string;
  description?: string | null;
  phone?: string | null;
  email?: string | null;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  country?: string | null;
  timeZone?: string | null;
  isPrimary: boolean;
  isActive: boolean;
  createdAt: string; // DateTime as ISO string
  updatedAt?: string | null; // DateTime as ISO string
  corporation?: CorporationDto | null;
}
